<template>
  <!-- <div class="tab--find clearfix">
    <div class="col-m-6 col-fit">
      <button
        class="btn btn--block btn--xxxl black text--white border border--black"
        :class="isFindId"
        @click="$router.push({name: 'findId'})"
      >아이디 찾기</button>
    </div>
    <div class="col-m-6 col-fit">
      <button
        class="btn btn--block btn--xxxl border"
        :class="isFindPwd"
        @click="$router.push({name: 'findPwd'})"
      >비밀번호 찾기</button>
    </div>
  </div> -->
  <div class="pb--32px">
    <div class="tabs columns--2 title-align--center">
      <div
        class="tab__title"
        :class="isFindId"
      >
        <a
          class=""
          @click="$router.push({name: 'findId'})"
        >아이디 찾기</a>
      </div>
      <div
        class="tab__title"
        :class="isFindPwd"
      >
        <a
          class=""
          @click="$router.push({name: 'findPwd'})"
        >비밀번호 찾기</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    isFindId () {
      return this.$route.name === 'findId' ? 'is-selected' : ''
    },
    isFindPwd () {
      return this.$route.name !== 'findId' ? 'is-selected' : ''
    }
  }
}
</script>
